module.exports = __webpack_public_path__ + "static/media/image_mapa.66856f51.jpeg";